"use client"

import { MenuRoleMappingPage } from "../../../modules/admin/menu-role-mapping"

interface MenuRoleMappingProps {
  sidebarOpen?: boolean
}

export default function MenuRoleMapping({ sidebarOpen }: MenuRoleMappingProps) {
  return (
    <div
      className={`w-full mb-6 p-4 lg:p-6 overflow-x-hidden ${!sidebarOpen ? "max-w-none" : "max-w-7xl mx-auto"}`}
    >
      <MenuRoleMappingPage />
    </div>
  )
}

